import { useEffect, useState } from 'react';
import { Notice, Panel } from '../components/Bits';
import { api } from '../lib/api';
import { saveSession } from '../lib/session';

/** Beitritt: Name eingeben und dann direkt in die Lobby. */
export function JoinView({
  code,
  onJoined,
}: {
  code: string;
  onJoined: () => void;
}) {
  const [name, setName] = useState('');
  const [lobbyPassword, setLobbyPassword] = useState('');

  const [info, setInfo] = useState<{
    open: boolean;
    players: number;
    maxPlayers: number;
    passwordRequired: boolean;
  } | null>(null);

  const [error, setError] =
    useState<string | null>(null);

  const [busy, setBusy] =
    useState(false);

  useEffect(() => {
    api
      .lobbyInfo(code)
      .then(setInfo)
      .catch((err: Error) =>
        setError(err.message),
      );
  }, [code]);

  async function join() {
    setBusy(true);
    setError(null);

    try {
      const res = await api.join(
        code,
        name.trim(),
        null,
        lobbyPassword,
      );

      saveSession(code, {
        playerId: res.playerId,
        token: res.token,
      });

      onJoined();
    } catch (err) {
      setError(
        (err as Error).message,
      );
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="page stack">
      <header>
        <h1>Noxbury, {code}</h1>

        {info && (
          <p className="muted">
            {info.open
              ? `${info.players} von ${info.maxPlayers} Plätzen belegt.`
              : 'Die Runde läuft bereits – ein Beitritt ist erst zur nächsten Runde möglich.'}
          </p>
        )}
      </header>

      <Panel title="Wer bist du?">
        <div className="field">
          <label htmlFor="name">
            Anzeigename
          </label>

          <input
            id="name"
            value={name}
            maxLength={24}
            onChange={(e) =>
              setName(e.target.value)
            }
          />
        </div>

        {info?.passwordRequired && (
          <div className="field">
            <label htmlFor="lobbypw">
              Lobby-Passwort
            </label>

            <input
              id="lobbypw"
              type="password"
              value={lobbyPassword}
              onChange={(e) =>
                setLobbyPassword(
                  e.target.value,
                )
              }
            />

            <p
              className="tiny muted"
              style={{
                marginTop: '0.3rem',
              }}
            >
              Das hat dir der Spielleiter
              zusammen mit dem Link geschickt.
            </p>
          </div>
        )}

        <button
          type="button"
          className="primary"
          style={{
            marginTop: '1rem',
          }}
          disabled={
            busy ||
            name.trim().length === 0 ||
            (info
              ? !info.open
              : false) ||
            (info?.passwordRequired
              ? lobbyPassword.length === 0
              : false)
          }
          onClick={() =>
            void join()
          }
        >
          Noxbury betreten
        </button>

        {error && (
          <Notice>
            {error}
          </Notice>
        )}
      </Panel>
    </main>
  );
}
